import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TokenSheet, DEFAULT_COIN, type Coin } from './TokenSheet';
import { ReceiveScreen } from './ReceiveScreen';
import { IncptReceiveScreen } from './IncptReceiveScreen';

type Step = 'token' | 'qr' | 'incpt';

/** Receive flow: select coin (unique symbols only) → show QR + network pills.
 *  When a coin is pre-selected (e.g. from a coin detail), the coin step is skipped. */
export function ReceiveFlow({ onClose, coin: initialCoin }: { onClose: () => void; coin?: Coin }) {
  const { t } = useTranslation();
  const [step, setStep] = useState<Step>(initialCoin ? 'qr' : 'token');
  const [coin, setCoin] = useState<Coin>(initialCoin ?? DEFAULT_COIN);

  return (
    <>
      {step === 'qr' && (
        <div className="push-enter fixed inset-0 z-50 overflow-y-auto bg-holo">
          <ReceiveScreen coin={coin} onClose={onClose} />
        </div>
      )}

      {step === 'incpt' && (
        <div className="push-enter fixed inset-0 z-50 overflow-y-auto bg-holo">
          <IncptReceiveScreen onClose={onClose} />
        </div>
      )}

      <TokenSheet
        open={step === 'token'}
        onClose={onClose}
        title={t('receive.topUpTitle')}
        uniqueOnly
        includeIncpt
        onSelectIncpt={() => setStep('incpt')}
        onSelect={(c) => {
          setCoin(c);
          setStep('qr');
        }}
      />
    </>
  );
}
